module.exports = __webpack_public_path__ + "static/media/rj_result_city2.230716b3.png";